<template>
  <v-container name='steper' id='steper' ref="steper" fluid pt-0>
    <v-layout row>
      <v-stepper class="w-100" v-model="currentStep">
        <v-stepper-header>
          <v-stepper-step :complete="currentStep >= 1" :editable="currentStep == 1" step="1">{{
            $t('message.apsHeader')
          }}</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="currentStep >= 2" :editable="currentStep == 2" step="2">{{
            $t('message.applicantHeader')
          }}</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="currentStep >= 3" :editable="currentStep == 3" step="3">{{
            $t('message.insuredHeader')
          }}</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="currentStep >= 4" :editable="currentStep == 4" step="4">{{
            $t('message.emissionDetailHeader')
          }}</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="currentStep >= 5" :editable="currentStep == 5" step="5">{{
            $t('message.paymentTypeOrder')
          }}</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="currentStep >= 6" :editable="currentStep == 6" step="6">{{
            $t('message.observations')
          }}</v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1">
            <v-container grid-list-xl text-xs-center fluid pa-0>
              <v-form data-vv-scope="step1">
                <v-layout row wrap>
                  <v-flex xs12 md6>
                    <v-autocomplete name="broker" v-bind:label="$t('message.aps')" v-validate="'required'"
                      :error-messages="errors.collect('step1.broker')" :error="errorBroker" :loading="loadingBroker"
                      :messages="errorMessageBroker" item-text="value" item-value="code" :items="catalogsBroker"
                      v-model="orderEmission.broker" clearable readonly disabled></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field v-bind:label="$t('message.apsEmail')" :counter="250" :maxlength="250" name="apsEmail"
                      v-validate="'required|email'" :error-messages="errors.collect('step1.apsEmail')"
                      v-model="orderEmission.apsEmail"></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap v-if="showApsVendor">
                  <v-flex xs12 md6>
                    <v-text-field v-bind:label="$t('message.apsVendorIdentification')"
                      v-validate="{ required: this.showApsVendor }" :maxlength="13" name="apsVendorIdentification"
                      @change.native="getVendorNames" :error-messages="errors.collect('step1.apsVendorIdentification')"
                      v-model="orderEmission.apsVendorIdentification" :readonly="disabledPromotor"></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field v-bind:label="$t('message.apsVendorNames')" :counter="100" :maxlength="100"
                      v-validate="{ required: this.showApsVendor }" name="apsVendorNames"
                      :error-messages="errors.collect('step1.apsVendorNames')" v-model="orderEmission.apsVendorNames"
                      readonly></v-text-field>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-container>
          </v-stepper-content>
          <v-stepper-content step="2">
            <v-container grid-list-xl text-xs-center fluid pa-0>
              <v-form data-vv-scope="step2">
                <v-layout row wrap>
                    <v-flex xs12 md6>
                      <v-select v-bind:label="$t('message.typePerson')" 
                      name="typePerson"
                      v-validate="'required'" 
                      :error-messages="errors.collect('step2.typePerson')"
                      :items="catalogsTypesPerson" 
                      item-text="value" 
                      item-value="code"
                      v-model="orderEmission.applicant.typePerson" 
                      @change="searchTypeIdentification(orderEmission.applicant.typePerson,'applicant')"></v-select>
                    </v-flex>
                  </v-layout>
                <v-layout row wrap>
                  <v-flex xs12 md6>
                    <v-select v-bind:label="$t('message.typeIdentification')" name="applicantTypeIdentification"
                      v-validate="'required'" :error-messages="errors.collect('step2.applicantTypeIdentification')"
                      :items="typeIdentificationAplicant" item-text="value" item-value="code"
                      v-model="orderEmission.applicant.typeIdentification" ></v-select>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field v-bind:label="$t('message.identification')"
                      :counter="orderEmission.applicant.typeIdentification === 'R' ? 13 : orderEmission.applicant.typeIdentification === 'P' ? 14 : 10"
                      :maxlength="orderEmission.applicant.typeIdentification === 'R' ? 13 : orderEmission.applicant.typeIdentification === 'P' ? 14 : 10"
                      name="identification" v-validate="'required|textAndNumber'"
                      :error-messages="errors.collect('step2.identification')"
                      v-model="orderEmission.applicant.identification"  @blur="searchApplicant"></v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout row wrap>
                  <v-flex xs12 md6  v-if="orderEmission.applicant.typePerson != 'J' ">
                    <v-text-field v-bind:label="$t('message.names')" :counter="50" :maxlength="50" name="names"
                      v-validate="'required'" :error-messages="errors.collect('step2.names')"
                      v-model="orderEmission.applicant.names"></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6  v-if="orderEmission.applicant.typePerson != 'J'">
                    <v-text-field v-bind:label="$t('message.surnames')" :counter="50" :maxlength="50" name="surnames"
                      v-validate="'required'" :error-messages="errors.collect('step2.surnames')"
                      v-model="orderEmission.applicant.surnames"></v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout row wrap>
                  <v-flex xs12 md6 v-if="tieneFvc">
                    <v-text-field v-bind:label="$t('message.stateFvc')" :counter="50" :maxlength="50" name="stateFvc"
                      readonly v-model="orderEmission.applicant.stateFvc"></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6 v-if="tieneFvc">
                    <v-text-field v-bind:label="$t('message.vigencyDateFvc')" name="vigencyDateFvc" readonly
                      v-model="orderEmission.applicant.vigencyDateFvc"
                      hint="(*Considerar que por política de la compañía para renovaciones anticipadas se requiere la actualización del Formulario de Vinculación 30 días antes de la Fecha Fin de Vigencia FVC)"
                      persistent-hint></v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout row wrap>
                  <v-flex xs12 md6 v-if="orderEmission.applicant.typePerson != 'J'">
                    <date-picker v-bind:label="$t('message.birthDate')" name="birthDate" v-validate="'required'"
                      :error-messages="errors.collect('step2.birthDate')"
                      v-model="orderEmission.applicant.birthDate"></date-picker>
                  </v-flex>
                  <v-flex xs12 md6 v-if="orderEmission.applicant.typePerson == 'J' ">
                    <v-text-field v-bind:label="$t('message.reasonSocial')" :counter="150" :maxlength="150"
                      name="reasonSocial" v-validate="'required'" :error-messages="errors.collect('step2.reasonSocial')"
                      v-model="orderEmission.applicant.reasonSocial"></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field v-bind:label="$t('message.emailApplicant')" :counter="50" :maxlength="50" name="email"
                      v-validate="'required|email|noAsurEmail'" :error-messages="errors.collect('step2.email')"
                      @change="changeValidateEmailIamApplicant" v-model="orderEmission.applicant.email"></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap v-if="orderEmission.applicant.typePerson != 'J' ">
                  <v-flex xs12 md6>
                    <v-select v-bind:label="$t('message.gender')" name="gender" v-validate="'required'"
                      :error-messages="errors.collect('step2.gender')" item-text="value" item-value="code"
                      :items="catalogsGender" v-model="orderEmission.applicant.gender"></v-select>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-select v-bind:label="$t('message.civilStatus')" name="civilStatus" v-validate="'required'"
                      :error-messages="errors.collect('step2.civilStatus')" item-text="value" item-value="code"
                      :items="catalogsCivilStatus" v-model="orderEmission.applicant.civilStatus"></v-select>
                  </v-flex>
                </v-layout>

                <v-layout row wrap>
                  <v-flex xs12 md6>
                    <v-autocomplete v-bind:label="$t('message.province')" name="province" v-validate="'required'"
                      :error-messages="errors.collect('step2.province')" item-text="value" item-value="code"
                      return-object :items="catalogsProvince" v-model="orderEmission.applicant.province"
                      @change="changeApplicantProvince"></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-autocomplete v-bind:label="$t('message.city')" name="city" v-validate="'required'"
                      :error-messages="errors.collect('step2.city')" item-text="value" item-value="code"
                      :items="applicantCatalogsCantonByProvince" v-model="orderEmission.applicant.city"
                      return-object></v-autocomplete>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs12 md6>
                    <v-text-field v-bind:label="$t('message.mainStreet')" :counter="50" :maxlength="50"
                      name="mainStreet" v-validate="'required'" :error-messages="errors.collect('step2.mainStreet')"
                      v-model="orderEmission.applicant.mainStreet"></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field v-bind:label="$t('message.secundaryStreet')" :counter="50" :maxlength="50"
                      name="secundaryStreet" v-validate="'required'"
                      :error-messages="errors.collect('step2.secundaryStreet')"
                      v-model="orderEmission.applicant.secundaryStreet"></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs12 md6>
                    <v-text-field v-bind:label="$t('message.number')" :counter="10" :maxlength="10" name="number"
                      v-validate="'required'" :error-messages="errors.collect('step2.number')"
                      v-model="orderEmission.applicant.number"></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field v-bind:label="$t('message.reference')" :counter="50" :maxlength="50" name="reference"
                      v-validate="'required'" :error-messages="errors.collect('step2.reference')"
                      v-model="orderEmission.applicant.reference"></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs12 md6>
                    <v-text-field v-bind:label="$t('message.telephone')" :counter="9" :maxlength="9" name="telephone"
                      v-validate="'digits:9|telephone'" :error-messages="errors.collect('step2.telephone')"
                      v-model="orderEmission.applicant.telephone" mask="(##) ####-###"></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field v-bind:label="$t('message.mobilePhone')" :counter="10" :maxlength="10"
                      name="mobilePhone" v-validate="'required|digits:10|start:09'"
                      :error-messages="errors.collect('step2.mobilePhone')"
                      v-model="orderEmission.applicant.mobilePhone" mask="(###) ###-####"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-container>
          </v-stepper-content>

          <v-stepper-content step="3">
            <v-container grid-list-xl text-xs-center fluid pa-0>
              <v-form data-vv-scope="step3">
                <v-layout row wrap>
                  <v-flex xs12 md6>
                    <v-checkbox v-bind:label="$t('message.infoPersonAsured')"
                      v-model="orderEmission.insuredSameApplicant"></v-checkbox>
                  </v-flex>
                  <v-flex xs12 md6>
                    <span class="caption light_caption--text text-sm-left font-italic v-input--selection-controls">{{
                      $t('message.dataSameApplicant')
                    }}</span>
                  </v-flex>
                </v-layout>
                <div v-if="!orderEmission.insuredSameApplicant">
                  <v-layout row wrap>
                    <v-flex xs12 md6>
                      <v-select v-bind:label="$t('message.typePerson')" 
                      name="typePerson"
                      v-validate="'required'" 
                      :error-messages="errors.collect('step3.typePerson')"
                      :items="catalogsTypesPerson" 
                      item-text="value" 
                      item-value="code"
                      v-model="orderEmission.insured.typePerson" 
                      @change="searchTypeIdentification(orderEmission.insured.typePerson,'insured')"></v-select>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs12 md6>
                      <v-select v-bind:label="$t('message.typeIdentification')" name="typeIdentification"
                        v-validate="'required'" :error-messages="errors.collect('step3.typeIdentification')"
                        item-text="value" item-value="code" :items="typeIdentificationInsured"
                        v-model="orderEmission.insured.typeIdentification"></v-select>
                    </v-flex>
                    <v-flex xs12 md6>
                      <v-text-field v-bind:label="$t('message.identification')"
                        :counter="orderEmission.insured.typeIdentification === 'R' ? 13 : orderEmission.insured.typeIdentification === 'P' ? 14 : 10"
                        :maxlength="orderEmission.insured.typeIdentification === 'R' ? 13 : orderEmission.insured.typeIdentification === 'P' ? 14 : 10"
                        name="identification" v-validate="'required|textAndNumber'"
                        :error-messages="errors.collect('step3.identification')"
                        v-model="orderEmission.insured.identification"   @blur="searchInsured"></v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout row wrap>
                    <v-flex xs12 md6 v-if="orderEmission.insured.typePerson != 'J'">
                      <v-text-field v-bind:label="$t('message.names')" :counter="50" :maxlength="50" name="names"
                        v-validate="'required'" :error-messages="errors.collect('step3.names')"
                        v-model="orderEmission.insured.names"></v-text-field>
                    </v-flex>
                    <v-flex xs12 md6 v-if="orderEmission.insured.typePerson != 'J'">
                      <v-text-field v-bind:label="$t('message.surnames')" :counter="50" :maxlength="50" name="surnames"
                        v-validate="'required'" :error-messages="errors.collect('step3.surnames')"
                        v-model="orderEmission.insured.surnames"></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs12 md6 v-if="orderEmission.insured.typePerson != 'J'">
                      <date-picker v-bind:label="$t('message.birthDate')" name="birthDate" v-validate="'required'"
                        :error-messages="errors.collect('step3.birthDate')"
                        v-model="orderEmission.insured.birthDate"></date-picker>
                    </v-flex>
                    <v-flex xs12 md6 v-if="orderEmission.insured.typePerson == 'J'">
                      <v-text-field v-bind:label="$t('message.reasonSocial')" :counter="150" :maxlength="150"
                        name="reasonSocial" v-validate="'required'"
                        :error-messages="errors.collect('step3.reasonSocial')"
                        v-model="orderEmission.insured.reasonSocial"></v-text-field>
                    </v-flex>
                    <v-flex xs12 md6>
                      <v-text-field v-bind:label="$t('message.email')" :counter="50" :maxlength="50" name="email"
                        v-validate="'required|email|noAsurEmail'" :error-messages="errors.collect('step3.email')"
                        @change="changeValidateEmailIamInsured" v-model="orderEmission.insured.email"></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap v-if="orderEmission.insured.typePerson != 'J'">
                    <v-flex xs12 md6>
                      <v-select v-bind:label="$t('message.gender')" name="gender" v-validate="'required'"
                        :error-messages="errors.collect('step3.gender')" item-text="value" item-value="code"
                        :items="catalogsGender" v-model="orderEmission.insured.gender"></v-select>
                    </v-flex>
                    <v-flex xs12 md6>
                      <v-select v-bind:label="$t('message.civilStatus')" name="civilStatus" v-validate="'required'"
                        :error-messages="errors.collect('step3.civilStatus')" item-text="value" item-value="code"
                        :items="catalogsCivilStatus" v-model="orderEmission.insured.civilStatus"></v-select>
                    </v-flex>
                  </v-layout>

                  <v-layout row wrap>
                    <v-flex xs12 md6>
                      <v-autocomplete v-bind:label="$t('message.province')" name="province" v-validate="'required'"
                        :error-messages="errors.collect('step3.province')" item-text="value" item-value="code"
                        return-object :items="catalogsProvince" v-model="orderEmission.insured.province"
                        @change="changeInsuredProvince"></v-autocomplete>
                    </v-flex>
                    <v-flex xs12 md6>
                      <v-autocomplete v-bind:label="$t('message.city')" name="city" v-validate="'required'"
                        :error-messages="errors.collect('step3.city')" item-text="value" item-value="code"
                        :items="insuredCatalogsCantonByProvince" v-model="orderEmission.insured.city"
                        return-object></v-autocomplete>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs12 md6>
                      <v-text-field v-bind:label="$t('message.mainStreet')" :counter="50" :maxlength="50"
                        name="mainStreet" v-validate="'required'" :error-messages="errors.collect('step3.mainStreet')"
                        v-model="orderEmission.insured.mainStreet"></v-text-field>
                    </v-flex>
                    <v-flex xs12 md6>
                      <v-text-field v-bind:label="$t('message.secundaryStreet')" :counter="50" :maxlength="50"
                        name="secundaryStreet" v-validate="'required'"
                        :error-messages="errors.collect('step3.secundaryStreet')"
                        v-model="orderEmission.insured.secundaryStreet"></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs12 md6>
                      <v-text-field v-bind:label="$t('message.number')" :counter="10" :maxlength="10" name="number"
                        v-validate="'required'" :error-messages="errors.collect('step3.number')"
                        v-model="orderEmission.insured.number"></v-text-field>
                    </v-flex>
                    <v-flex xs12 md6>
                      <v-text-field v-bind:label="$t('message.reference')" :counter="50" :maxlength="50"
                        name="reference" v-validate="'required'" :error-messages="errors.collect('step3.reference')"
                        v-model="orderEmission.insured.reference"></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs12 md6>
                      <v-text-field v-bind:label="$t('message.telephone')" :counter="9" :maxlength="9" name="telephone"
                        v-validate="'digits:9|telephone'" :error-messages="errors.collect('step3.telephone')"
                        v-model="orderEmission.insured.telephone" mask="(##) ####-###"></v-text-field>
                    </v-flex>
                    <v-flex xs12 md6>
                      <v-text-field v-bind:label="$t('message.mobilePhone')" :counter="10" :maxlength="10"
                        name="mobilePhone" v-validate="'required|digits:10|start:09'"
                        :error-messages="errors.collect('step3.mobilePhone')"
                        v-model="orderEmission.insured.mobilePhone" mask="(###) ###-####"></v-text-field>
                    </v-flex>
                  </v-layout>
                </div>
              </v-form>
            </v-container>
          </v-stepper-content>

          <v-stepper-content step="4">
            <v-container grid-list-xl text-xs-center fluid pa-0>
              <v-form data-vv-scope="step4">
                <v-layout row wrap>
                  <v-flex xs12 md6>
                      <v-autocomplete :label="$t('message.isProductClose')" name="isProductClose" v-validate="'required'"
                        :error-messages="errors.collect('step4.isProductClose')"
                        :items="[{ code: 'S', value: 'Sí' }, { code: 'N', value: 'No' }]" item-text="value"
                        item-value="code" v-model="orderEmission.emissionDetail.productClose"
                        @change="obtenerLineaNegocioProductoCerrado"></v-autocomplete>

                      <!-- Mostrar el texto alineado al inicio -->
                      <div v-if="orderEmission.emissionDetail.productClose" class="caption mt-1"
                        style="text-align:left;">
                        <strong>{{ lineaNegocioText }}</strong>
                      </div>
                    </v-flex>
                  <v-flex xs12 md6>
                    <v-autocomplete v-bind:label="$t('message.emisionType')" name="emisionType" v-validate="'required'"
                      :error-messages="errors.collect('step4.emisionType')" item-text="value" item-value="code"
                      :items="catalogsEmisionToEmit"
                      v-model="orderEmission.emissionDetail.emisionType"></v-autocomplete>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs12 md6>
                    <v-menu ref="menu" lazy :close-on-content-click="false" v-model="menu" transition="scale-transition"
                      offset-y full-width :nudge-right="40" min-width="290px"
                      :return-value.sync="orderEmission.emissionDetail.validSince">
                      <v-text-field slot="activator" v-bind:label="$t('message.validSince')"
                        v-model="orderEmission.emissionDetail.validSince" name="validSince" append-icon="event"
                        :error="errorSince" :messages="errorSinceMessage" v-validate="'required|date_format:YYYY-MM-DD'"
                        ref="validSince" :error-messages="errors.collect('step4.validSince')"
                        data-vv-name-on="validSince"></v-text-field>
                      <v-date-picker v-model="orderEmission.emissionDetail.validSince" scrollable locale="es-la">
                        <v-spacer></v-spacer>
                        <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
                        <v-btn flat color="primary"
                          @click="calcDays(orderEmission.emissionDetail.validSince)">Ok</v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-menu ref="menu2" lazy :close-on-content-click="false" v-model="menu2"
                      transition="scale-transition" offset-y full-width :nudge-right="40" min-width="290px"
                      :return-value.sync="orderEmission.emissionDetail.validUntil">
                      <v-text-field slot="activator" v-bind:label="$t('message.validUntil')"
                        v-model="orderEmission.emissionDetail.validUntil" name="validUntil" ref="validUntil"
                        :error="errorUntil" append-icon="event"
                        v-validate="'required|date_format:YYYY-MM-DD|after:validSince'"
                        :error-messages="errors.collect('step4.validUntil')" data-vv-name="validUntil"></v-text-field>
                      <v-date-picker v-model="orderEmission.emissionDetail.validUntil" scrollable locale="es-la">
                        <v-spacer></v-spacer>
                        <v-btn flat color="primary" @click="menu2 = false">Cancel</v-btn>
                        <v-btn flat color="primary"
                          @click="$refs.menu2.save(orderEmission.emissionDetail.validUntil)">Ok</v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs12 md6>
                    <v-autocomplete v-bind:label="$t('message.bouquetDetailToEmit')" name="bouquetDetailToEmit"
                      v-validate="'required'" @change="changeProducts(orderEmission.emissionDetail.bouquetDetailToEmit)"
                      :error-messages="errors.collect('step4.bouquetDetailToEmit')" item-text="value" item-value="code"
                      :items="catalogsRamosToEmit"
                      v-model="orderEmission.emissionDetail.bouquetDetailToEmit"></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 md6 v-if="orderEmission.emissionDetail.bouquetDetailToEmit === '40' || orderEmission.emissionDetail.bouquetDetailToEmit === '4' ">
                    <v-autocomplete v-bind:label="$t('message.product')" name="product" v-validate="'required'"
                      :error-messages="errors.collect('step4.product')" item-text="value" item-value="code"
                      :items="catalogsProductsAll"                      
                      v-model="orderEmission.emissionDetail.product"></v-autocomplete>
                  </v-flex>                 
                </v-layout>

                <v-layout row wrap>
                  <v-flex xs12 md12>
                    <v-textarea v-bind:label="$t('message.emissionDetail')" name="emissionDetail"
                      v-validate="'required'" :error-messages="errors.collect('step4.emissionDetail')"
                      v-model="orderEmission.emissionDetail.observations" :counter="2000" :maxlength="2000"
                      rows="4"></v-textarea>
                  </v-flex>
                </v-layout>
                <!-- <v-layout row wrap>
                  <v-flex xs12 md6>
                    <v-select v-bind:label="$t('message.requiredInspectionGeneral')" name="requiredInspection"
                      v-validate="'required'" :error-messages="errors.collect('step4.requiredInspection')"
                      item-text="value" item-value="code" :items="catalogsDesicion"
                      v-model="orderEmission.emissionDetail.requiredInspection"></v-select>
                  </v-flex>
                </v-layout> -->

                <v-container grid-list-xl text-xs-center fluid mt-3
                  v-if="orderEmission.emissionDetail.requiredInspection === 'S'">
                  <v-flex row wrap>
                    <v-flex subheading text-uppercase light_caption--text>{{ $t('message.inspectionHeader') }}</v-flex>
                  </v-flex>
                  <v-layout row wrap>
                    <v-flex xs12 md6>
                      <v-text-field v-bind:label="$t('message.names')" :counter="50" :maxlength="50" name="names"
                        v-model="orderEmission.inspection.name"></v-text-field>
                    </v-flex>
                    <v-flex xs12 md6>
                      <v-text-field v-bind:label="$t('message.surnames')" :counter="50" :maxlength="50" name="surnames"
                        v-model="orderEmission.inspection.surnames"></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs12 md6>
                      <v-text-field v-bind:label="$t('message.telephone')" :maxlength="10" :rules="validateTelephone"
                        name="telephone" v-model="orderEmission.inspection.telephone" mask="##########"></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-container>
          </v-stepper-content>

          <v-stepper-content step="5">
            <v-container grid-list-xl text-xs-center fluid pa-0>
              <v-form data-vv-scope="step5">
                <v-layout row wrap>
                  <v-flex xs12 md6>
                    <v-select v-bind:label="$t('message.paymentMethod')" name="paymentMethod" v-validate="'required'"
                      :error-messages="errors.collect('step5.paymentMethod')" item-text="value" item-value="code"
                      :items="catalogsPaymentMethodByGrouper" v-model="orderEmission.paymentMethod"
                      return-object></v-select>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-select v-if="orderEmission.paymentMethod && orderEmission.paymentMethod.code.includes('11')"
                      v-bind:label="$t('message.quota')" name="quota" v-validate="'required'" item-text="value"
                      item-value="code" :error-messages="errors.collect('step5.quota')" :items="catalogsQuota"
                      v-model="orderEmission.quota"></v-select>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-container>
          </v-stepper-content>

          <v-stepper-content step="6">
            <v-container grid-list-xl text-xs-center fluid pa-0>
              <v-form data-vv-scope="step6">
                <v-layout row wrap v-if="loadingSectionFvc">
                  <v-flex xs12 md6>
                    <v-select v-bind:label="$t('message.sendToEmailLinkWeb')" name="sendToEmailLinkWeb"
                      data-vv-name="sendToEmailLinkWeb" v-validate="'required'"
                      :error-messages="errors.collect('step6.sendToEmailLinkWeb')" :items="catalogsGestorFvc"
                      @change="changeSendToEmailLinkWeb" v-model="orderEmission.sendToEmailLinkWeb"
                      item-text="value"
                      item-value="code" 
                      return-object></v-select>
                  </v-flex>
                  <v-flex xs12 md6 style="position:relative;">
                    <div class="text-xs-center d-flex align-center"
                      style="position:absolute; right:30px; color:#BDBDBD; top:20px; width:10px; height:10px;cursor: pointer; z-index:2">
                      <v-tooltip bottom>
                        <v-icon slot="activator" class="rounded-circle"
                          style="color:#00aeef; border: 1px solid #c0c0c0">help</v-icon>
                        <span style="max-width:300px !important; display:inline-block; text-align:justify;">
                          A este correo se enviará el formulario de vinculación WEB para el ingreso de los datos del
                          cliente</span>
                      </v-tooltip>
                    </div>
                    <v-text-field v-bind:label="$t('message.email')" :counter="50" :maxlength="50" name="email"
                      :disabled="!editMail" v-validate="'required|email'"
                      :error-messages="errors.collect('step6.email')" v-model="orderEmission.emailFvc"></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6 style="position:relative;">
                    <div class="text-xs-center d-flex align-center"
                      style="position:absolute; right:30px; color:#BDBDBD; top:20px; width:10px; height:10px;cursor: pointer; z-index:2">
                      <v-tooltip bottom>
                        <v-icon slot="activator" class="rounded-circle"
                          style="color:#00aeef; border: 1px solid #c0c0c0">help</v-icon>
                        <span style="max-width:300px !important; display:inline-block; text-align:justify;">
                          Recordar que el firmante es el cliente y éste correo fue ingresado en “Datos del
                          Solicitante.</span>
                      </v-tooltip>
                    </div>
                    <v-text-field v-model="orderEmission.applicant.email" v-bind:label="$t('message.policySendToEmail')"
                      disabled></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs12 md6>
                    <!-- <file-upload
                      v-bind:label="$t('message.fileLocal')"
                      v-bind:hint="$t('message.attachementHint')"
                      name="fileLocal"                   
                      v-bind:error-messages="errors.collect('step6.fileLocal')"
                      v-model="file"
                    ></file-upload> -->
                    <file-drag-drop v-model="filelist">
                    </file-drag-drop>
                  </v-flex>
                  <v-flex xs12 md6 text-xs-center subheading light_caption--text>{{
                    $t('message.orderEmissionNote')
                  }}</v-flex>
                </v-layout>
              </v-form>
            </v-container>
          </v-stepper-content>
        </v-stepper-items>
        <v-layout row wrap>
          <v-flex xs6>
            <img src="/static/img/Tracking-horizontal.png" alt="site logo" width="150" height="46" style="float: left;">
          </v-flex>
          <v-flex xs6>
            <v-flex xs12 text-lg-right>
              <v-btn @click="cancel">{{ $t('message.cancel') }}</v-btn>
              <v-btn @click="beforeStep()" v-if="currentStep > 1" color="accent">{{ $t('message.before') }}</v-btn>
              <v-btn @click="nextStep()" color="accent">{{ currentStep == 6 ? $t('message.save') : $t('message.next')
              }}</v-btn>
            </v-flex>
          </v-flex>
        </v-layout>
      </v-stepper>
      <OrderEmisionPlaModal ref="orderEmisionPlaModal"></OrderEmisionPlaModal>
    </v-layout>
    <SavePopupErrors ref="SavePopupErrors">
    </SavePopupErrors>
  </v-container>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import router from "@/router";

//import FileUpload from "@/components/FileUpload/FileUpload";
import DatePicker from "@/components/DatePicker/DatePicker";

import OrderEmissionServices from "@/services/OrderEmissionServices";
import CustomerServices from "@/services/CustomerServices";
import ApsServices from "@/services/ApsServices";
import VehicleServices from "@/services/VehicleServices";
import CatalogServices from "@/services/CatalogsServices";
import ComunServices from "@/services/ComunServices";
import FvcServices from "@/services/FvcServices";

import { typeIdentification } from "@/common/helpers/helpers";
import { convertDataURIToBinary } from "@/common/helpers/helpers";
import { getDate } from "@/common/helpers/helpers";
import moment from "moment";
import FileDragDrop from "@/components/FileDragDrop/FileDragDrop";
import SavePopupErrors from "@/views/orderEmision/SavePopupErrors";
import OrderEmisionPlaModal from "./OrderEmisionPlaModal";

export default {
  components: {
    //FileUpload,
    DatePicker,
    FileDragDrop,
    SavePopupErrors,
    OrderEmisionPlaModal
  },
  computed: {
    ...mapGetters([
      "loadingOrderEmission",
      "loadingCatalogs",
      "catalogsBroker",
      "catalogsGender",
      "catalogsCivilStatus",
      "catalogsProvince",
      "catalogsRamosToEmit",
      "catalogsVehicleBrands",
      "catalogsVehicleModels",
      "catalogsQuota",
      "catalogsPaymentMethodByPersonType",
      "catalogsAutototalGroupers",
      "catalogsTypeCoverage",
      "catalogsTypesIdentification",
      "catalogsTypesPerson",
      "catalogsMultiriesgo",
      "catalogsMultiriesgoTecny",
      "mailToSendForm",
      "typesCollectPromissoryNoteWithBankDebit",
      "userProfile",
      "agencyId",
      "userScopes",
      "trueFalseOptions",
      "catalogsDesicion",
      "catalogsPaymentMethodByGrouper",
      "catalogsEmisionToEmit",
      "catalogsGestorFvc",
      "catalogsProduct"
    ]),
  },
  mounted() {
    this.changeSendToEmailLinkWeb();
    this.$store.dispatch("getCatalogsBroker").then(() => {
      this.orderEmission.apsEmail = this.userProfile.email;

      if (this.userScopes.includes("aps_executive") || this.userScopes.includes("aps_promotor")) {
        this.orderEmission.broker = this.userProfile.aps
        this.loadingBroker = false;

      } else {
        this.orderEmission.broker = this.userProfile.user_id;
        this.loadingBroker = false;

      }
      //Valida dominio de correo @cifraseg.net.ec para mostrar vendedor
      if (this.userProfile.email.indexOf("@cifraseg.net.ec") > -1) {
        this.showApsVendor = true;
      }

      if (this.userScopes.includes("aps_promotor")) {
        this.orderEmission.apsVendorIdentification = this.userProfile.identity
        this.loading = true;
        this.getVendorNames();
        this.showApsVendor = true;
        this.disabledPromotor = true
      } else {
        this.disabledPromotor = false
      }
    });
    this.$store.dispatch("getCatalogsGender");
    this.$store.dispatch("getCatalogsCivilStatus");
    this.$store.dispatch("getCatalogsProvince");
    this.$store.dispatch("getCatalogsAllRamosToEmit");
    this.$store.dispatch("getCatalogsAllProducts");
    this.$store.dispatch("getCatalogsTypeCoverage");
    this.$store.dispatch("getAllAutototalGroupers");
    this.$store.dispatch("getAllTypesIdentification");
    this.$store.dispatch("getAllTypesPerson");
    this.$store.dispatch("getQuota");
    this.$store.dispatch("getcatalogsDesicion");
    this.$store.dispatch("getCatalogsPaymentMethodByGrouper");
    this.$store.dispatch("getCatalogsAllTypeEmisionToEmit");
    this.$store.dispatch("getcatalogsGestorFvc");
  },
  watch: {
    "orderEmission.broker"(val) {
      if (val == null) {
        this.errorBroker = true;
        this.errorMessageBroker = "El campo APS es requerido";
      } else {
        this.errorBroker = false;
        this.errorMessageBroker = "";
      }
    },
    "orderEmission.emissionDetail.validSince"(val) {
      if (
        this.orderEmission.emissionDetail.validSince >
        this.orderEmission.emissionDetail.validUntil &&
        this.orderEmission.emissionDetail.validUntil != ""
      ) {
        this.errorSince = true;
        this.errorSinceMessage =
          "El campo Vigencia desde debe ser anterior o igual a Vigencia hasta";
      } else {
        this.errorSince = false;
        this.errorSinceMessage = "";
      }
    },
    "orderEmission.emissionDetail.validUntil"(val) {
      if (
        this.orderEmission.emissionDetail.validSince >
        this.orderEmission.emissionDetail.validUntil &&
        this.orderEmission.emissionDetail.validUntil != ""
      ) {
        this.errorSince = true;
        this.errorSinceMessage =
          "El campo Vigencia desde debe ser anterior o igual a Vigencia hasta";
      } else {
        this.errorSince = false;
        this.errorSinceMessage = "";
      }
    },
    // "orderEmission.applicant.reasonSocial"(val) {
    //   this.orderEmission.applicant.names = val;
    //   this.orderEmission.applicant.surnames = ".";
    // },
    "orderEmission.applicant.typePerson"() {
      this.orderEmission.applicant.typeIdentification = null;
      this.orderEmission.applicant.identification = "";
      this.orderEmission.applicant.stateFvc = "";
      this.orderEmission.applicant.vigencyDateFvc = "";
      this.orderEmission.applicant.names = "";
      this.orderEmission.applicant.surnames = "";
      this.orderEmission.applicant.birthDate = undefined;
      this.orderEmission.applicant.gender = undefined;
      this.orderEmission.applicant.reasonSocial ="";
    },
    "orderEmission.applicant.typeIdentification"() {
      this.orderEmission.applicant.identification = "";
      this.orderEmission.applicant.stateFvc = "";
      this.orderEmission.applicant.vigencyDateFvc = "";
      this.orderEmission.applicant.names = "";
      this.orderEmission.applicant.surnames = "";
      this.orderEmission.applicant.birthDate = undefined;
      this.orderEmission.applicant.gender = undefined;
      this.orderEmission.applicant.reasonSocial ="";
    },
    "orderEmission.insured.typePerson"() {
      this.orderEmission.insured.typeIdentification = null;
      this.orderEmission.insured.identification = "";
      this.orderEmission.insured.names = "";
      this.orderEmission.insured.surnames = "";
      this.orderEmission.insured.birthDate = undefined;
      this.orderEmission.insured.gender = undefined;
      this.orderEmission.insured.reasonSocial ="";
    },
    "orderEmission.insured.typeIdentification"() {
      this.orderEmission.insured.identification = "";
      this.orderEmission.insured.names = "";
      this.orderEmission.insured.surnames = "";
      this.orderEmission.insured.birthDate = undefined;
      this.orderEmission.insured.gender = undefined;
      this.orderEmission.insured.reasonSocial ="";
    },
    // "orderEmission.insured.reasonSocial"(val) {
    //   this.orderEmission.insured.names = val;
    //   this.orderEmission.insured.surnames = ".";
    // },
    loading(val) {
      if (val) {
        this.$root.$emit(
          "showLoading",
          "Cargando información, por favor espere..."
        );
      } else {
        setTimeout(() => {
          this.$root.$emit("hideLoading");
        }, 1000);
      }
    },
    loadingCatalogs(val) {
      if (val) {
        this.$root.$emit("showLoading", "Cargando catálogos");
      } else {
        setTimeout(() => {
          this.$root.$emit("hideLoading");
        }, 1000);
      }
    },
    loadingOrderEmission(val) {
      if (val) {
        this.$root.$emit("showLoading", "Registrando orden de emisión");
      } else {
        this.$root.$emit("hideLoading");
      }
    },
  },
  delimiters: ["${", "}"],
  data() {
    return {
      timeout: null,
      typeIdentificationAplicant:[],
      typeIdentificationInsured:[],
      patronCedula : /^[0-3]{1}[0-9]{1}([0-6]){1}[0-9]{7}$/,
      patronPasaporte : /^[0-9a-zA-Z]{5,}$/,
      patronRucJuridico : /^((0[1-9]|1[0-9]|2[0-4])(6|9)[0-9]{7}(001))?$/,
      patronRucNatural : /^[0-3]{1}[0-9]{1}([0-6]){1}[0-9]{7}001$/,
      loadingBroker: true,
      errorBroker: false,
      errorMessageBroker: "",
      errorUntil: false,
      errorSince: false,
      errorSinceMessage: "",
      date: null,
      modal: false,
      modal2: false,
      menu: false,
      menu2: false,
      userCreatorName: "",
      editAPS: true,
      applicantCatalogsCantonByProvince: [],
      insuredCatalogsCantonByProvince: [],
      loading: false,
      currentStep: 1,
      valid: false,
      editMail: true,
      file: undefined,
      typeIdentificationApplicant: undefined,
      catalogsProductsAll: [],
      showApsVendor: false,
      disabledPromotor: false,
      lineaNegocio: "",
      lineaNegocioText: "",
      orderEmission: {
        broker: "",
        apsEmail: "",
        apsVendorIdentification: "",
        apsVendorNames: "",
        agency: "", //IAM
        applicant: {
          typePerson:"",
          typeIdentification: "",
          identification:"",
          names: undefined,
          surnames: undefined,
          gender: undefined,
          birthDate: undefined,
          email: undefined,
          reasonSocial: undefined,
          stateFvc: undefined,
          vigencyDateFvc: undefined,
          telephone: undefined,
          mobilePhone: undefined,
          mainStreet: undefined,
          secundaryStreet: undefined,
          esPep: "N",
          esObservado: "N"
        },
        insuredSameApplicant: false,
        insured: {
          typePerson:"",
          typeIdentification: "",
          identification:"",
          names: undefined,
          surnames: undefined,
          gender: undefined,
          birthDate: undefined,
          email: undefined,
          reasonSocial: undefined,
          telephone: undefined,
          mobilePhone: undefined,
          mainStreet: undefined,
          secundaryStreet: undefined,
          esPep: "N",
          esObservado: "N"
        },
        emissionDetail: {
          assuredValueHelmet: 0,
          extraValue: 0,
          assuredValueTotal: 0,
          validSince: "",
          validUntil: "",
          vehicleBrand: "",
          // validSince: null,
          // validUntil: null,
          year: "",
          product: "",
          requiredInspection: "N"
        },

        inspection: {
          name: "",
          surnames: "",
          telephone: ""
        },

        notificationTo: "",
        emailFvc: "",
        sendToEmailLinkWeb:{code:"1",value:"CLIENTE"}
      },
      loadingSectionFvc: true,
      validateTelephone: [v => /^.{9,10}$/.test(v) || "Teléfono incorrecto"],
      emailIam: {},
      tieneFvc: false,
      filelist: [],
      adjuntosFile: [],
      adjuntosName: [],
      insuredBlackList: false,
      applicantBlackList: false,
    };
  },
  methods: {
    obtenerLineaNegocioProductoCerrado() {
      const valor = this.orderEmission.emissionDetail.productClose;
      if (valor === 'S') {
        this.lineaNegocio = '17';

        this.lineaNegocioText = 'Línea de Negocio PERSONAS'
      }

      if (valor === 'N') {
        this.lineaNegocio = '3';
        this.lineaNegocioText = 'Línea de Negocio CORPORATIVO'
      }
    },
    searchTypeIdentification(tipoPersona,persona){
      if(tipoPersona == "N"){
        if(persona == "applicant"){
          this.typeIdentificationAplicant = this.catalogsTypesIdentification.filter(({code}) => (code == "C" || code == "R" || code == "P")  );
        }else{
          this.typeIdentificationInsured = this.catalogsTypesIdentification.filter(({code}) => (code == "C" || code == "R" || code == "P")  );
        } 

      }else if(tipoPersona == "J"){
        if(persona == "applicant"){
        this.typeIdentificationAplicant =  this.catalogsTypesIdentification.filter(({code}) => (code == "R" )  );
        }else{
          this.typeIdentificationInsured =  this.catalogsTypesIdentification.filter(({code}) => (code == "R" )  );
        }
        
      }
      

    },
    
    
    calcDays(val) {
      if (val) {
        this.$root.$emit("showLoading", "Calculando fecha");
        if (this.orderEmission.emissionDetail.validSince) {
          this.orderEmission.emissionDetail.validUntil = moment(
            this.orderEmission.emissionDetail.validSince,
            "YYYY-MM-DD"
          )
            .add(1, "year")
            .format()
            .substring(0, 10);

          this.$refs.menu2.save(
            this.orderEmission.emissionDetail.validUntil
          );
          this.$refs.menu.save(
            this.orderEmission.emissionDetail.validSince
          );

          this.errorSince = false;
          this.errorSinceMessage = "";
        }
        this.$root.$emit("hideLoading");
      } else {
        this.menu = false;
      }
    },
    typeIdentification: typeIdentification,
    updateAssuredValueTotal() {
      this.orderEmission.emissionDetail.assuredValueTotal =
        parseFloat(this.orderEmission.emissionDetail.assuredValueHelmet) +
        parseFloat(this.orderEmission.emissionDetail.extraValue);
    },
async changeProducts(codigoRamo){      
      if(codigoRamo == "40"){//Multiriesgo
        await CatalogServices.getAllProduct()
        .then((response) => {
          this.catalogsProductsAll  = response.data.data.filter(({code}) => (code == "8" || code == "167"))
        })        
      }      
      if(codigoRamo == "4"){//AccidentesPersonales
        await CatalogServices.getAllProduct()
        .then((response) => {
        this.catalogsProductsAll = response.data.data.filter(({code}) => (code == "132" || code == "136" || code == "18"));
      })}
    },
    async changeInsuredProvince() {
      if (this.orderEmission.insured.province) {
        this.loading = true;
        CatalogServices.getCantonByProvince(
          this.orderEmission.insured.province.code
        )
          .then((response) => {

            this.insuredCatalogsCantonByProvince = response.data.data;
          })
          .catch((res) => {
            this.$root.$emit("showSnackBar", "Error desconocido", "error");
          })
          .finally((res) => {
            this.loading = false;
          });
      } else {
        this.insuredCatalogsCantonByProvince = [];
      }
    },
    async getApsInfo() {
      let idAps = "";
      await CatalogServices.getDataApsInfo()

        .then((response) => {
          idAps = response.data.data.filter(({ codeSiaerp }) => (codeSiaerp == this.orderEmission.broker))[0]["code"]

        })


      return idAps;
    },
    async getVendorNames() {
  
      this.orderEmission.apsVendorNames = "";
      if (this.orderEmission.apsVendorIdentification) 
      {
        this.loading = true;
        let aps = await this.getApsInfo();

        await OrderEmissionServices.getEjecutivoAgenteIdentificacion(aps, this.orderEmission.apsVendorIdentification)
          .then((response) => {
            if (response.data.Error == 0) {
              const vendor = response.data.Data.Descripcion;
              this.orderEmission.apsVendorNames =
                vendor;
            } else {
              this.$root.$emit(
                "showSnackBar",
                "No existe vendedor con identificación " +
                this.orderEmission.apsVendorIdentification,
                "error"
              );
            }
          })
          .catch((res) => {
            this.$root.$emit("showSnackBar", "No existe vendedor con identificación", "error");

          })
          .finally((res) => {
            this.loading = false;
          });

      }

    },

    async searchInsured() {
      if (
        (this.orderEmission.insured.typeIdentification === 'C' && this.orderEmission.insured.typePerson === 'N' && this.patronCedula.test(this.orderEmission.insured.identification)) ||
        (this.orderEmission.insured.typeIdentification === 'P' && this.orderEmission.insured.typePerson === 'N' && this.patronPasaporte.test(this.orderEmission.insured.identification)) ||
        (this.orderEmission.insured.typeIdentification === 'R' && this.orderEmission.insured.typePerson === 'J' && this.patronRucJuridico.test(this.orderEmission.insured.identification)) ||
        (this.orderEmission.insured.typeIdentification === 'R' && this.orderEmission.insured.typePerson === 'N' && this.patronRucNatural.test(this.orderEmission.insured.identification))
      ) 
      {
        if (this.orderEmission.insured.identification) {
        this.loading = true;
        if (
          this.orderEmission.insured.typeIdentification == "R" &&
          this.orderEmission.insured.identification.length != 13
        ) {
          this.$root.$emit(
            "showSnackBar",
            "Identificación " + this.orderEmission.insured.identification + " incorrecta, se requieren 13 dígitos",
            "error"
          );
          this.orderEmission.insured.identification = "";
          this.loading = false;
        } else if (
          this.orderEmission.insured.typeIdentification == "C" &&
          this.orderEmission.insured.identification.length != 10
        ) {
          this.$root.$emit(
            "showSnackBar",
            "Identificación " + this.orderEmission.insured.identification + " incorrecta, se requieren 10 dígitos",
            "error"
          );
          this.orderEmission.insured.identification = "";
          this.loading = false;
        } else if (
          this.orderEmission.insured.typeIdentification == "P" &&
          this.orderEmission.insured.identification.length > 14
        ) {
          this.$root.$emit(
            "showSnackBar",
            "Identificación " + this.orderEmission.insured.identification + " incorrecta, se requieren 10 dígitos",
            "error"
          );
          this.orderEmission.insured.identification = "";
          this.loading = false;
        } else if (this.orderEmission.insured.typeIdentification == "P") {
          CustomerServices.get(this.orderEmission.insured.identification)
            .then((response) => {
              const customer = response.data.data;
              this.orderEmission.insured.names = "";
              this.orderEmission.insured.surnames = "";
              this.orderEmission.insured.birthDate = undefined;
              this.orderEmission.insured.gender = undefined;

              this.orderEmission.insured.email = customer.email;
              this.orderEmission.insured.telephone = customer.telephone;
              this.orderEmission.insured.mobilePhone = customer.mobilePhone;
              this.orderEmission.insured.mainStreet = customer.mainStreet;
              this.orderEmission.insured.secundaryStreet = customer.secundaryStreet;

              this.insuredBlackList = customer.blackList == "S" ? true : false;
              this.orderEmission.insured.esPep = customer.pep;
                  this.orderEmission.insured.esObservado = customer.blackList;
              if(this.insuredBlackList){
                this.$refs.orderEmisionPlaModal.openDialog(customer.fullName);
                this.orderEmission.insured.identification = "";
                this.loading = false;
              }

              if (customer.identification) {
                if (this.orderEmission.insured.typeIdentification == "R" && this.orderEmission.insured.typePerson == "J") {
                  if (customer.fullName) {
                    this.orderEmission.insured.reasonSocial = customer.fullName;
                    this.orderEmission.insured.names =
                      customer.fullName;
                  }else{
                    this.orderEmission.insured.names = ".";
                  }
                  this.orderEmission.insured.surnames = ".";
                  if (customer.birthdate) {
                    const birthDate = getDate(customer.birthdate, "DD-MM-YYYY");
                    this.orderEmission.insured.birthDate = birthDate
                      .toISOString()
                      .substring(0, 10);
                  }

                  if (customer.gender) {
                    const catalog = this.catalogsGender.find(
                      (c) => c.code.toUpperCase() == customer.gender.toUpperCase()
                    );
                    if (catalog) {
                      this.orderEmission.insured.gender = catalog.code;
                    }
                  }
                } else {
                  this.orderEmission.insured.names =
                    customer.firstName +
                    (customer.secondName ? " " + customer.secondName : "");
                  this.orderEmission.insured.surnames =
                    customer.surname +
                    (customer.secondSurname ? " " + customer.secondSurname : "");

                  if (customer.birthdate) {
                    const birthDate = getDate(customer.birthdate, "DD-MM-YYYY");
                    this.orderEmission.insured.birthDate = birthDate
                      .toISOString()
                      .substring(0, 10);
                  }

                  if (customer.gender) {
                    const catalog = this.catalogsGender.find(
                      (c) => c.code.toUpperCase() == customer.gender.toUpperCase()
                    );
                    if (catalog) {
                      this.orderEmission.insured.gender = catalog.code;
                    }
                  }
                }
              }
              this.loading = false;
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          ComunServices.validateIdentification(this.orderEmission.insured.identification).then(
            (res) => {
              const valido = res.data.data;
              if (valido) {
                CustomerServices.get(this.orderEmission.insured.identification)
                  .then((response) => {
                    const customer = response.data.data;
                    this.orderEmission.insured.names = "";
                    this.orderEmission.insured.surnames = "";
                    this.orderEmission.insured.birthDate = undefined;
                    this.orderEmission.insured.gender = undefined;

                    this.orderEmission.insured.email = customer.email;
                    this.orderEmission.insured.telephone = customer.telephone;
                    this.orderEmission.insured.mobilePhone = customer.mobilePhone;
                    this.orderEmission.insured.mainStreet = customer.mainStreet;
                    this.orderEmission.insured.secundaryStreet = customer.secundaryStreet;

                    this.insuredBlackList = customer.blackList == "S" ? true : false;
                    this.orderEmission.insured.esPep = customer.pep;
                    this.orderEmission.insured.esObservado = customer.blackList;
                    if(this.insuredBlackList){
                      this.$refs.orderEmisionPlaModal.openDialog(customer.fullName);
                      this.orderEmission.insured.identification = "";
                      this.loading = false;
                    }

                    if (customer.identification) {
                      if (this.orderEmission.insured.typeIdentification == "R" && this.orderEmission.insured.typePerson == "J") {
                        if (customer.fullName) {
                          this.orderEmission.insured.reasonSocial = customer.fullName;
                          this.orderEmission.insured.names =
                            customer.fullName;
                        }else{
                            this.orderEmission.insured.names = ".";
                        }
                        this.orderEmission.insured.surnames = ".";
                        if (customer.birthdate) {
                          const birthDate = getDate(customer.birthdate, "DD-MM-YYYY");
                          this.orderEmission.insured.birthDate = birthDate
                            .toISOString()
                            .substring(0, 10);
                        }

                        if (customer.gender) {
                          const catalog = this.catalogsGender.find(
                            (c) => c.code.toUpperCase() == customer.gender.toUpperCase()
                          );
                          if (catalog) {
                            this.orderEmission.insured.gender = catalog.code;
                          }
                        }
                      } else {
                        this.orderEmission.insured.names =
                          customer.firstName +
                          (customer.secondName ? " " + customer.secondName : "");
                        this.orderEmission.insured.surnames =
                          customer.surname +
                          (customer.secondSurname ? " " + customer.secondSurname : "");

                        if (customer.birthdate) {
                          const birthDate = getDate(customer.birthdate, "DD-MM-YYYY");
                          this.orderEmission.insured.birthDate = birthDate
                            .toISOString()
                            .substring(0, 10);
                        }

                        if (customer.gender) {
                          const catalog = this.catalogsGender.find(
                            (c) => c.code.toUpperCase() == customer.gender.toUpperCase()
                          );
                          if (catalog) {
                            this.orderEmission.insured.gender = catalog.code;
                          }
                        }
                      }
                    }
                    this.loading = false;
                  })
                  .catch(() => {
                    this.loading = false;
                  });
              } else {
                this.$root.$emit(
                  "showSnackBar",
                  "La Identificación " + this.orderEmission.insured.identification + " no es un documento válido",
                  "error"
                );
                this.orderEmission.insured.identification = "";
                this.loading = false;
              }
            })
        }
      }


      }else{
            var ident = null;
              if( this.orderEmission.insured.typePerson == "" ){
              this.$root.$emit(
                  "showSnackBar",
                  "Seleccione el Tipo de Persona",
                  "error"
                );
                this.orderEmission.insured.identification = ident;

              }else if( this.orderEmission.insured.typeIdentification == "" ){

              this.$root.$emit(
                  "showSnackBar",
                  "Seleccione el Tipo de Identificación",
                  "error"
                );
                this.orderEmission.insured.identification = ident;
              }else{
              this.$root.$emit(
                  "showSnackBar",
                  "Identificación " + this.orderEmission.insured.identification + " incorrecta, “Número de identificación incorrecto",
                  "error"
                );
                this.orderEmission.insured.identification = ident;

              }

              this.loading = false;

      }
     
    },

    changeSendToEmailLinkWeb() {
      
      if (this.orderEmission.sendToEmailLinkWeb.code == "2") {
        this.editMail = false;
        this.orderEmission.emailFvc = this.orderEmission.apsEmail;
      } else if (this.orderEmission.sendToEmailLinkWeb.code == "1") {
        this.orderEmission.emailFvc = this.orderEmission.applicant.email;
        this.editMail = false;
      } else {
        this.orderEmission.emailFvc = "";
        this.editMail = true;
      }
    },

    async changeValidateEmailIamApplicant() {
      if (this.orderEmission.applicant.email) {
        this.loading = true;
        var emailModel = {
          email: this.orderEmission.applicant.email,
        };
        OrderEmissionServices.validateEmailIam(emailModel)
          .then((response) => {
            this.emailIam = response.data.data;
            if (this.emailIam.Registrado) {
              this.$root.$emit(
                "showSnackBar",
                "Correo no permitido para el Solicitante de la emisión ",
                "error"
              );
              this.orderEmission.applicant.email = "";
            }
          })
          .catch((res) => {
            this.$root.$emit("showSnackBar", "Error desconocido", "error");
          })
          .finally((res) => {
            this.loading = false;
          });
      } else {
        this.applicantCatalogsCantonByProvince = [];
      }
      this.changeSendToEmailLinkWeb();
    },
    async changeValidateEmailIamInsured() {
      if (this.orderEmission.insured.email) {
        this.loading = true;
        var emailModel = {
          email: this.orderEmission.insured.email,
        };
        OrderEmissionServices.validateEmailIam(emailModel)
          .then((response) => {
            this.emailIam = response.data.data;
            if (this.emailIam.Registrado) {
              this.$root.$emit(
                "showSnackBar",
                "Correo no permitido para el Asegurado de la emisión ",
                "error"
              );
              this.orderEmission.insured.email = "";
            }
          })
          .catch((res) => {
            this.$root.$emit("showSnackBar", "Error desconocido", "error");
          })
          .finally((res) => {
            this.loading = false;
          });
      } else {
        this.applicantCatalogsCantonByProvince = [];
      }
    },

    async changeApplicantProvince() {
      if (this.orderEmission.applicant.province) {
        this.loading = true;
        await CatalogServices.getCantonByProvince(
          this.orderEmission.applicant.province.code
        )
          .then((response) => {
            this.applicantCatalogsCantonByProvince = response.data.data;

          })
          .catch((res) => {
            this.$root.$emit("showSnackBar", "Error desconocido", "error");
          })
          .finally((res) => {
            this.loading = false;
          });
      } else {
        this.applicantCatalogsCantonByProvince = [];
      }
    },
    async searchApplicant() {


    if (
    (this.orderEmission.applicant.typeIdentification === 'C' && this.orderEmission.applicant.typePerson === 'N' && this.patronCedula.test(this.orderEmission.applicant.identification)) ||
    (this.orderEmission.applicant.typeIdentification === 'P' && this.orderEmission.applicant.typePerson === 'N' && this.patronPasaporte.test(this.orderEmission.applicant.identification)) ||
    (this.orderEmission.applicant.typeIdentification === 'R' && this.orderEmission.applicant.typePerson === 'J' && this.patronRucJuridico.test(this.orderEmission.applicant.identification)) ||
    (this.orderEmission.applicant.typeIdentification === 'R' && this.orderEmission.applicant.typePerson === 'N' && this.patronRucNatural.test(this.orderEmission.applicant.identification))
    ) 
    {
    if (this.orderEmission.applicant.identification) {
        const typeIdentification = this.typeIdentification(
          this.orderEmission.applicant.identification
        );
        this.$store.dispatch(
          "getCatalogsPaymentMethodByPersonType",
          typeIdentification
        );

        this.loading = true;

        if (
          this.orderEmission.applicant.typeIdentification == "R" &&
          this.orderEmission.applicant.identification.length != 13
        ) {
          this.$root.$emit(
            "showSnackBar",
            "Identificación " + this.orderEmission.applicant.identification + " incorrecta, se requieren 13 dígitos",
            "error"
          );
          this.orderEmission.applicant.identification = "";
          this.loading = false;
        } else if (
          this.orderEmission.applicant.typeIdentification == "C" &&
          this.orderEmission.applicant.identification.length != 10
        ) {
          this.$root.$emit(
            "showSnackBar",
            "Identificación " + this.orderEmission.applicant.identification + " incorrecta, se requieren 10 dígitos",
            "error"
          );
          this.orderEmission.applicant.identification = "";
          this.loading = false;
        } else if (
          this.orderEmission.applicant.typeIdentification == "P" &&
          this.orderEmission.applicant.identification.length > 14
        ) {
          this.$root.$emit(
            "showSnackBar",
            "Identificación " + this.orderEmission.applicant.identification + " incorrecta, se requieren 10 dígitos",
            "error"
          );
          this.orderEmission.applicant.identification = "";
          this.loading = false;
        } else if (this.orderEmission.applicant.typeIdentification == "P") {
          // const caracter = this.orderEmission.applicant.identification.substr(2,1);
          // if(this.orderEmission.applicant.identification.length == 13 && (caracter == "6" || caracter == "9")){
          this.loadingSectionFvc = true;
          // }else{
          //   this.loadingSectionFvc = false;
          // }

          CustomerServices.get(this.orderEmission.applicant.identification)
            .then((response) => {
              const customer = response.data.data;
              this.orderEmission.applicant.names = "";
              this.orderEmission.applicant.surnames = "";
              this.orderEmission.applicant.birthDate = undefined;
              this.orderEmission.applicant.gender = undefined;

              this.orderEmission.applicant.email = customer.email;
              this.orderEmission.applicant.telephone = customer.telephone;
              this.orderEmission.applicant.mobilePhone = customer.mobilePhone;
              this.orderEmission.applicant.mainStreet = customer.mainStreet;
              this.orderEmission.applicant.secundaryStreet = customer.secundaryStreet;

              this.applicantBlackList = customer.blackList == "S" ? true : false
              this.orderEmission.applicant.esPep = customer.pep;
                  this.orderEmission.applicant.esObservado = customer.blackList;

              if(this.applicantBlackList){
                this.$refs.orderEmisionPlaModal.openDialog(customer.fullName);
                this.orderEmission.applicant.identification = "";
                this.loading = false;
              }

              if (customer.identification) {
                if (this.orderEmission.applicant.typeIdentification == "R") {
                  if (customer.fullName) {
                    this.orderEmission.applicant.reasonSocial = customer.fullName;
                    this.orderEmission.applicant.names =
                      customer.fullName;
                  }else{
                    this.orderEmission.applicant.names = ".";
                  }
                  this.orderEmission.applicant.surnames = ".";
                  if (customer.birthdate) {
                    const birthDate = getDate(customer.birthdate, "DD-MM-YYYY");
                    this.orderEmission.applicant.birthDate = birthDate
                      .toISOString()
                      .substring(0, 10);
                  }

                  if (customer.gender) {
                    const catalog = this.catalogsGender.find(
                      (c) => c.code.toUpperCase() == customer.gender.toUpperCase()
                    );
                    if (catalog) {
                      this.orderEmission.applicant.gender = catalog.code;
                    }
                  }
                } else {
                  this.orderEmission.applicant.names =
                    customer.firstName +
                    (customer.secondName ? " " + customer.secondName : "");
                  this.orderEmission.applicant.surnames =
                    customer.surname +
                    (customer.secondSurname ? " " + customer.secondSurname : "");

                  if (customer.birthdate) {
                    const birthDate = getDate(customer.birthdate, "DD-MM-YYYY");
                    this.orderEmission.applicant.birthDate = birthDate
                      .toISOString()
                      .substring(0, 10);
                  }

                  if (customer.gender) {
                    const catalog = this.catalogsGender.find(
                      (c) => c.code.toUpperCase() == customer.gender.toUpperCase()
                    );
                    if (catalog) {
                      this.orderEmission.applicant.gender = catalog.code;
                    }
                  }
                }
              }
              this.loading = false;
            })
            .catch(() => {
              this.loading = false;
            });

          FvcServices.get(this.orderEmission.applicant.identification)
            .then(res => {
              const fvc = res.data;
              if (fvc.data != null) {
                this.tieneFvc = true
                this.orderEmission.applicant.stateFvc = fvc.data.state
                this.orderEmission.applicant.vigencyDateFvc = fvc.data.vigencyDate

                var date1 = fvc.data.vigencyDate
                var newdate1 = date1.split("/").reverse().join("-");

                let fechaVigencyTemp = moment(newdate1, "YYYY-MM-DD")
                  .format()
                  .substring(0, 10);
                let fechaHoy = moment(new Date(), "YYYY-MM-DD")
                  .add(30, "day")
                  .format()
                  .substring(0, 10);

                if (fechaVigencyTemp < fechaHoy) {
                  this.loadingSectionFvc = true
                } else {
                  this.loadingSectionFvc = false
                }

              } else {
                this.tieneFvc = false
                this.orderEmission.applicant.stateFvc = undefined
                this.orderEmission.applicant.vigencyDateFvc = undefined
              }

            })
        } else {
          ComunServices.validateIdentification(this.orderEmission.applicant.identification).then(
            (res) => {
              const valido = res.data.data;
              if (valido) {
                // const caracter = this.orderEmission.applicant.identification.substr(2,1);
                // if(this.orderEmission.applicant.identification.length == 13 && (caracter == "6" || caracter == "9")){
                this.loadingSectionFvc = true;
                // }else{
                //   this.loadingSectionFvc = false;
                // }

                CustomerServices.get(this.orderEmission.applicant.identification)
                  .then((response) => {
                    const customer = response.data.data;
                    this.orderEmission.applicant.names = "";
                    this.orderEmission.applicant.surnames = "";
                    this.orderEmission.applicant.birthDate = undefined;
                    this.orderEmission.applicant.gender = undefined;

                    this.orderEmission.applicant.email = customer.email;
                    this.orderEmission.applicant.telephone = customer.telephone;
                    this.orderEmission.applicant.mobilePhone = customer.mobilePhone;
                    this.orderEmission.applicant.mainStreet = customer.mainStreet;
                    this.orderEmission.applicant.secundaryStreet = customer.secundaryStreet;

                    this.applicantBlackList = customer.blackList == "S" ? true : false
                    this.orderEmission.applicant.esPep = customer.pep;
                  this.orderEmission.applicant.esObservado = customer.blackList;

                    if(this.applicantBlackList){
                      this.$refs.orderEmisionPlaModal.openDialog(customer.fullName);
                      this.orderEmission.applicant.identification = "";
                      this.loading = false;
                    }

                    if (customer.identification) {
                      if (this.orderEmission.applicant.typeIdentification == "R") {
                        if (customer.fullName) {
                          this.orderEmission.applicant.reasonSocial = customer.fullName;
                          this.orderEmission.applicant.names =
                            customer.fullName;
                        }else{
                          this.orderEmission.applicant.names = ".";
                        }
                        this.orderEmission.applicant.surnames = ".";
                        if (customer.birthdate) {
                          const birthDate = getDate(customer.birthdate, "DD-MM-YYYY");
                          this.orderEmission.applicant.birthDate = birthDate
                            .toISOString()
                            .substring(0, 10);
                        }

                        if (customer.gender) {
                          const catalog = this.catalogsGender.find(
                            (c) => c.code.toUpperCase() == customer.gender.toUpperCase()
                          );
                          if (catalog) {
                            this.orderEmission.applicant.gender = catalog.code;
                          }
                        }
                      } else {
                        this.orderEmission.applicant.names =
                          customer.firstName +
                          (customer.secondName ? " " + customer.secondName : "");
                        this.orderEmission.applicant.surnames =
                          customer.surname +
                          (customer.secondSurname ? " " + customer.secondSurname : "");

                        if (customer.birthdate) {
                          const birthDate = getDate(customer.birthdate, "DD-MM-YYYY");
                          this.orderEmission.applicant.birthDate = birthDate
                            .toISOString()
                            .substring(0, 10);
                        }

                        if (customer.gender) {
                          const catalog = this.catalogsGender.find(
                            (c) => c.code.toUpperCase() == customer.gender.toUpperCase()
                          );
                          if (catalog) {
                            this.orderEmission.applicant.gender = catalog.code;
                          }
                        }
                      }
                    }
                    this.loading = false;
                  })
                  .catch(() => {
                    this.loading = false;
                  });

                FvcServices.get(this.orderEmission.applicant.identification)
                  .then(res => {
                    const fvc = res.data;
                    if (fvc.data != null) {
                      this.tieneFvc = true
                      this.orderEmission.applicant.stateFvc = fvc.data.state
                      this.orderEmission.applicant.vigencyDateFvc = fvc.data.vigencyDate

                      var date1 = fvc.data.vigencyDate
                      var newdate1 = date1.split("/").reverse().join("-");

                      let fechaVigencyTemp = moment(newdate1, "YYYY-MM-DD")
                        .format()
                        .substring(0, 10);
                      let fechaHoy = moment(new Date(), "YYYY-MM-DD")
                        .add(30, "day")
                        .format()
                        .substring(0, 10);

                      if (fechaVigencyTemp < fechaHoy) {
                        this.loadingSectionFvc = true
                      } else {
                        this.loadingSectionFvc = false
                      }

                    } else {
                      this.tieneFvc = false
                      this.orderEmission.applicant.stateFvc = undefined
                      this.orderEmission.applicant.vigencyDateFvc = undefined
                    }

                  })
              } else {
                this.$root.$emit(
                  "showSnackBar",
                  "La Identificación " + this.orderEmission.applicant.identification + " no es un documento válido",
                  "error"
                );
                this.orderEmission.applicant.identification = "";
                this.loading = false;
              }
            }
          );
        }
      }

    }else 
      {
        var ident = null;

            if( this.orderEmission.applicant.typePerson == "" ){
            this.$root.$emit(
                "showSnackBar",
                "Seleccione el Tipo de Persona",
                "error"
              );
              
              this.orderEmission.applicant.identification = ident;
          
          }else if( this.orderEmission.applicant.typeIdentification == "" ){

            this.$root.$emit(
                "showSnackBar",
                "Seleccione el Tipo de Identificación",
                "error"
              );
            
            
              this.orderEmission.applicant.identification = ident;
          }else{

            this.$root.$emit(
                "showSnackBar",
                "Identificación " + this.orderEmission.applicant.identification + " incorrecta, “Número de identificación incorrecto",
                "error"
              );
              this.orderEmission.applicant.identification = ident;
            

          }
          
      
          this.loading = false;
      }

      
    },

    clear() {
      this.$validator.reset();
    },

    cancel() {
      this.$router.push("/orderEmision");
    },
    nextStep() {
      if (this.errorBroker) {
        return;
      } else {
        this.$validator.validateAll("step" + this.currentStep).then((valid) => {
          if (valid) {
            if (this.currentStep === 6) {
              this.newOrderEmision();
            } else {
              this.$refs.steper.parentElement.scroll(0, 0);
              this.currentStep++;
            }
          }
        });
      }
    },
    beforeStep() {
      this.$refs.steper.parentElement.scroll(0, 0);
      this.currentStep--;
    },

    async newOrderEmision() {
      this.userProfile.user_id;
      let idAps = 0;
      let fullName = "";

      this.loading = true;
      idAps = await this.getApsInfo();


      if (
        this.userProfile.first_name != "" &&
        this.userProfile.first_name != null
      ) {
        fullName += this.userProfile.first_name;
      }

      if (
        this.userProfile.second_name != "" &&
        this.userProfile.second_name != null
      ) {
        fullName += " " + this.userProfile.second_name;
      }

      if (
        this.userProfile.first_surname != "" &&
        this.userProfile.first_surname != null
      ) {
        fullName += " " + this.userProfile.first_surname;
      }

      if (
        this.userProfile.second_surname != "" &&
        this.userProfile.second_surname != null
      ) {
        fullName += " " + this.userProfile.second_surname;
      }

      let attachement = this.filelist.filelist; //this.file ? this.file.imageFile : null;

      if (attachement != undefined) {
        this.adjuntosFile = attachement.map(function (item) {
          return convertDataURIToBinary(item.urlFile);
        });
        this.adjuntosName = attachement.map(function (item) {
          return item.nameFile;
        });
      }
      let solicitante = {
        Apellidos: this.orderEmission.applicant.surnames,
        Nombres: this.orderEmission.applicant.names,
        Correo: this.orderEmission.applicant.email,
        Direccion: {
          CallePrincipal: this.orderEmission.applicant.mainStreet,
          CalleSecundaria: this.orderEmission.applicant.secundaryStreet,
          Ciudad: {
            Codigo: this.orderEmission.applicant.city.code
          },
          Numeracion: this.orderEmission.applicant.number,
          Provincia: {
            Codigo: this.orderEmission.applicant.province.code
          },
          Referencia: this.orderEmission.applicant.reference
        },
        EstadoCivil: {
          Codigo: this.orderEmission.applicant.civilStatus == null || this.orderEmission.applicant.civilStatus == "" || this.orderEmission.applicant.civilStatus == "undefined" ? "" : this.orderEmission.applicant.civilStatus
        },
        FechaNacimiento: this.orderEmission.applicant.birthDate,
        Genero: {
          Codigo: this.orderEmission.applicant.gender == null || this.orderEmission.applicant.gender == "" || this.orderEmission.applicant.gender == "undefined" ? "" : this.orderEmission.applicant.gender
        },
        Identificacion: this.orderEmission.applicant.identification,
        RazonSocial: this.orderEmission.applicant.reasonSocial,
        TelefonoCelular: this.orderEmission.applicant.mobilePhone,
        TelefonoFijo: this.orderEmission.applicant.telephone == "" || this.orderEmission.applicant.telephone == null || this.orderEmission.applicant.telephone == "undefined" ? "0" : this.orderEmission.applicant.telephone,
        TipoIdentificacion: {
          Codigo: this.orderEmission.applicant.typeIdentification == null || this.orderEmission.applicant.typeIdentification == "" || this.orderEmission.applicant.typeIdentification == "undefined" ? "" : this.orderEmission.applicant.typeIdentification
        },
        TipoPersona: {
          Codigo: this.orderEmission.applicant.typePerson
        },
        EsPep: this.orderEmission.applicant.esPep,
        esObservado: this.orderEmission.applicant.esObservado,

      }
      let asegurado;
      !this.orderEmission.insuredSameApplicant ? asegurado = {
        Apellidos: this.orderEmission.insured.surnames,
        Nombres: this.orderEmission.insured.names,
        Correo: this.orderEmission.insured.email,
        Direccion: {
          CallePrincipal: this.orderEmission.insured.mainStreet,
          CalleSecundaria: this.orderEmission.insured.secundaryStreet,
          Ciudad: {
            Codigo: this.orderEmission.insured.city.code
          },
          Numeracion: this.orderEmission.insured.number,
          Provincia: {
            Codigo: this.orderEmission.insured.province.code
          },
          Referencia: this.orderEmission.insured.reference
        },
        EstadoCivil: {
          Codigo: this.orderEmission.insured.civilStatus == null || this.orderEmission.insured.civilStatus == "" || this.orderEmission.insured.civilStatus == "undefined" ? "" : this.orderEmission.insured.civilStatus
        },
        FechaNacimiento: this.orderEmission.insured.birthDate,
        Genero: {
          Codigo: this.orderEmission.insured.gender == null || this.orderEmission.insured.gender == "" || this.orderEmission.insured.gender == "undefined" ? "" : this.orderEmission.insured.gender
        },
        Identificacion: this.orderEmission.insured.identification,
        RazonSocial: this.orderEmission.insured.reasonSocial,
        TelefonoCelular: this.orderEmission.insured.mobilePhone,
        TelefonoFijo: this.orderEmission.insured.telephone == "" || this.orderEmission.insured.telephone == null || this.orderEmission.insured.telephone == "undefined" ? "0" : this.orderEmission.insured.telephone,
        TipoIdentificacion: {
          Codigo: this.orderEmission.insured.typeIdentification == null || this.orderEmission.insured.typeIdentification == "" || this.orderEmission.insured.typeIdentification == "undefined" ? "" : this.orderEmission.insured.typeIdentification
        },
        TipoPersona: {
          Codigo: this.orderEmission.insured.typePerson
        },
        EsPep: this.orderEmission.insured.esPep,
        esObservado: this.orderEmission.insured.esObservado,

      } : asegurado = solicitante;
      let archivosAdjuntos = [];
      if (this.adjuntosFile != 0) {
        for (var i = 0; i < this.adjuntosFile.length; i++) {
          archivosAdjuntos.push({
            Nombre: this.adjuntosName[i] == null ? "" : this.adjuntosName[i],
            Base64: "",
            Buffer: this.adjuntosFile[i]
          })

        }
      }

      let emisionOrder = {
        FuenteEmi: "OficinaVirtual",
        Vendedor: {
          Identificacion: this.orderEmission.apsVendorIdentification,
          Nombres: this.orderEmission.apsVendorNames,
        },
        Aps: {
          Codigo: idAps,
          IdSiaerp: 0,
        },
        Sucursal: {
          Codigo: "",
          IdSiaerp:this.agencyId
        },
        LineaNegocio: {
          Codigo: this.lineaNegocio
        },
        Ramo: {
          Codigo: this.orderEmission.emissionDetail.bouquetDetailToEmit
        },
        NumeroPoliza: 0,
        VigenciaDesde: this.orderEmission.emissionDetail.validSince,
        VigenciaHasta: this.orderEmission.emissionDetail.validUntil,
        esReproceso: {
          Codigo: "N"

        },
        TipoReproceso: {
          Codigo: "0"
        },
        EsUrgente: {
          Codigo: "N"
        },
        MotivoUrgencia: {
          Codigo: "0"
        },
        TipoFormulario: {
          Codigo: "2"
        },
        TipoOrdenEmision: {
          Codigo: "1"
        },
        TipoEndodo: {
          Codigo: "12"
        },
        motivoEndosoNegativo: {
          Codigo: ""
        },
        tipoCuentaPublica: {
          Codigo: ""
        },
        FormaPagoCuentaPublica: "",
        tieneReaseguro: {
          Codigo: ""
        },
        requiereAsistencia: {
          Codigo: ""
        },
        esFacultativo: {
          Codigo: ""
        },
        Canal: {
          Codigo: ""
        },
        Producto: {
          Codigo: this.orderEmission.emissionDetail.product
        },
        TamanioCarga: {
          Codigo: ""
        },
        PagoCuota: {
          Codigo: this.orderEmission.quota == "" || this.orderEmission.quota == null || this.orderEmission.quota == "undefined" ? "" : this.orderEmission.quota
        },
        TipoEmision: {
          Codigo: this.orderEmission.emissionDetail.emisionType
        },
        PorcentajeComision: 0,
        Markup: 0,
        NumeroCertificados: 0,
        FechaEntrega: new Date(),
        HoraEntrega: "",
        Solicitante: solicitante,
        Asegurado: !this.orderEmission.insuredSameApplicant ? asegurado : solicitante,
        FechaCotizacion: new Date(),
        UsuarioCreador: {
          TipoCreador: "",
          Codigo: this.userProfile.identity,
          IdSiaerp: this.userProfile.user_id == null || this.userProfile.user_id == "" || this.userProfile.user_id == "undefined" ? "" : this.userProfile.user_id
        },
        RequiereInspeccion: {
          Codigo: this.orderEmission.emissionDetail.requiredInspection
        },
        ContactoInspeccion: {
          ContactoApellidos: this.orderEmission.inspection.surnames,
          ContactoNombres: this.orderEmission.inspection.name,
          ContactoTelefono: this.orderEmission.inspection.telephone
        },
        Vehiculo: {
          Anio: 0,
          Autotal: {
            Codigo: "",
          },
          EsNuevo: {
            Codigo: this.orderEmission.emissionDetail.requiredInspection == "N" ? "S" : "N"
          },
          Marca: {
            Codigo: ""
          },
          PlacaCamv: "",
          TienePlaca: {
            Codigo: ""
          },
          TipoCobertura: { Codigo: "" }
        },
        ValorAsegurado: this.orderEmission.emissionDetail.assuredValueHelmet,
        ValorExtras: this.orderEmission.emissionDetail.extraValue,
        ValorTotal: this.orderEmission.emissionDetail.assuredValueTotal,
        DetalleEmision: this.orderEmission.emissionDetail.observations,
        NumeroOrden: "",
        Fvc: {
          CorreoEnvioFormulario: this.orderEmission.emailFvc,
          EstadoFormulario: this.orderEmission.applicant.stateFvc == null || this.orderEmission.applicant.stateFvc == "undefined" || this.orderEmission.applicant.stateFvc == "" ? "0" : this.orderEmission.applicant.stateFvc,
          FechaFinVigencia: this.orderEmission.emissionDetail.validUntil,
          Gestor: {
            Codigo: this.orderEmission.sendToEmailLinkWeb == null || this.orderEmission.sendToEmailLinkWeb == undefined ? "1": this.orderEmission.sendToEmailLinkWeb.code
          }
        },
        FormaPago: {
          Codigo: this.orderEmission.paymentMethod.code
        },
        Adjuntos: archivosAdjuntos
      }

      this.$root.$emit("showLoading", "Registrando nueva orden de emisión");

      if(emisionOrder.Sucursal.IdSiaerp == null || emisionOrder.Sucursal.IdSiaerp == undefined
          || emisionOrder.Sucursal.IdSiaerp =="")
      {
        this.$root.$emit(
                  "showSnackBar",
                  "Sesión caducada",
                  "error"
                );
        localStorage.clear();
        this.$store.dispatch("logoutUser");
        this.$router.push("/session/login");
        location.reload();
      }
      else{
            OrderEmissionServices.createOrderEmision(emisionOrder)
              .then((response) => {
                if (response.data.error == 0) {
                  this.loading = false;
                  this.$root.$emit(
                    "showSnackBar",
                    "Orden de emisión " +
                    response.data.data.data.noOrdenEmision +
                    " creada correctamente",
                    "success"
                  );
                  this.$root.$emit("hideLoading");
                  router.push("/orderEmision/orderEmisionList");
                } else {
                  this.loading = false;
                  this.$refs.SavePopupErrors.show(response.data.data.data.trace);
                }
              })
              .catch((error) => {
                this.loading = false;
                this.$root.$emit("hideLoading");
                this.$root.$emit(
                  "showSnackBar",
                  "Error creando la orden de emisión:" + error.message,
                  "error"
                );
              });
            }
    },

  }
};
</script>
